import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-route-placeholder',
  standalone: true,
  imports: [],
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class RoutePlaceholderComponent {}
